@if(!loaded()){  } @if (loaded() && uniqueSearches().length > 0) {
<ul
    [id]="id()"
    [attr.data-testId]="currentTestId()"
    [attr.data-styletarget]="id()"
    [attr.data-uitype]="'list'"
    class="list-none"
>
    @for (search of uniqueSearches(); track $index) {
    <li
        [id]="id() + '-item-' + $index"
        [attr.data-testId]="currentTestId() + '-item-' + $index"
        [attr.data-styletarget]="id() + '-item-' + $index"
        [attr.data-uitype]="'list-item'"
        class="grid mb-4 px-4 py-1.5 gap-4 border-solid border-[1px] border-gray-100 rounded items-center grid-cols-[80px_184px_24px_184px_64px_100px]"
    >
        <div class="text-dat-grey-500 font-body-2">{{ search.date }}</div>
        <div class="text-dat-grey-900 font-body-2">
            <span>{{ search.origin }} </span>
        </div>
        <div class="text-right pr-2">
            <span class="material-symbols-outlined text-dat-grey-900 pt-1">
                arrow_forward
            </span>
        </div>

        <div class="text-dat-grey-900 font-body-2">
            {{ search.destination }}
        </div>
        <div class="text-dat-grey-900 font-body-2">{{ search.equipment }}</div>
        <div class="text-center">
            <button
                class="bg-white font-button-strong hover:bg-dat-grey-100 font-medium text-dat-blue-500 rounded-full px-4 py-2 cursor-pointer"
                (click)="click(search)"
            >
                Search
            </button>
        </div>
    </li>
    }
</ul>
} @if (loaded() && uniqueSearches().length === 0) {
<div class="flex flex-col items-center text-center h-[740px] w-[740px] py-12">
    <mat-icon class="!h-[64px] !w-[64px]" svgIcon="app:empty_box"></mat-icon>
    <div
        class="datiq-screen-error__container datiq-screen-error__container--message"
    >
        <h1 class="text-dat-grey-500 font-body-large-strong">
            {{ title ?? '--' }}
        </h1>
        <section>
            <span class="text-dat-grey-500 font-body-large">{{
                message ?? '--'
            }}</span>
        </section>
    </div>
</div>
}
